import { Chip } from '@design/components/chip/Chip';
import { FlagIcon } from '@design/components/flag-icon/FlagIcon';
import { MouseEvent } from 'react';

import { FollowedCountry } from '../utils';
import styles from './FollowCountryPill.module.scss';

export interface FollowCountryPillProps {
  followedCountry: FollowedCountry;
  onRemove: (e: MouseEvent) => void;
}

/**
 * @deprecated
 */
export const FollowCountryPill = ({
  followedCountry,
  onRemove,
}: FollowCountryPillProps) => (
  <Chip
    className={styles.pill}
    type="filter"
    label={followedCountry.name}
    assetLogo={
      <FlagIcon
        countryCode={followedCountry.code}
        variant="circular"
        customSize={16}
      />
    }
    onRightIconClick={onRemove}
    data-testid={`follow-countries-pill-${followedCountry.code}`}
  />
);
